/* Series selector: apply a complete vehicle to the URL, links, filters and analytics. */
(async function () {
  const root = document.querySelector('.bd-series'), C = window.BDFitCore;
  if (!root || !C) return;
  const picker = root.querySelector('[data-series-picker]');
  const status = root.querySelector('[data-vehicle-status]');
  const clear = root.querySelector('[data-clear-vehicle]');
  const apply = root.querySelector('[data-apply-vehicle]');
  const cfg = JSON.parse(root.querySelector('[data-series-config]').textContent);
  const key = C.resolveKey(cfg.apiKey), fields = ['year', 'make', 'model', 'trim'];
  let draft = null, controls, hydrating = true;
  function links() {
    const current = new URLSearchParams(location.search);
    root.querySelectorAll('[data-series-link], [data-gallery] a').forEach(a => {
      const u = new URL(a.href, location.origin);
      fields.forEach(k => { u.searchParams.delete(k); if (current.has(k)) u.searchParams.set(k, current.get(k)); });
      a.href = u.pathname + u.search + u.hash;
    });
  }
  function write(saved) {
    const u = new URL(location.href), values = saved ? {...saved.slugs, trim: saved.trim} : {};
    fields.forEach(k => { u.searchParams.delete(k); if (values[k] && values[k] !== '*') u.searchParams.set(k, values[k]); });
    history.replaceState(null, '', u.pathname + u.search + u.hash);
    clear.hidden = !saved; links();
  }
  function announce(saved) {
    root.dispatchEvent(new CustomEvent('bd:series-vehicle', {detail: saved}));
  }
  function accept(saved, capture = false) {
    if (saved) C.saveVehicle(saved); else C.clearVehicle();
    root._seriesVehicle = saved;
    write(saved); announce(saved);
    status.textContent = saved ? 'Showing options for ' + saved.vehicle.label : '';
    if (capture && typeof window.posthog?.capture === 'function') {
      window.posthog.capture('vehicle_selected', {source: 'series_landing', campaign: root.dataset.series,
        ...saved.slugs, trim: saved.trim || null, vehicle: saved.vehicle.label, $current_url: location.href,
        ...Object.fromEntries([...new URLSearchParams(location.search)].filter(([k]) => k.startsWith('utm_')))});
    }
  }
  if (!key) { status.textContent = 'Vehicle lookup is unavailable. Contact our team for help.'; return; }
  const api = C.makeApi(key);
  let initial = null;
  try {
    const params = new URLSearchParams(location.search);
    const explicit = fields.some(k => params.has(k));
    initial = explicit ? await C.resolveVehicleFromUrl(api) : C.loadVehicle();
    if (initial) accept(initial);
  } catch (_) { status.textContent = 'Could not load that vehicle. Choose it below or contact our team.'; }
  function mount(value) {
    hydrating = true; draft = null; apply.disabled = true;
    controls = C.mountPicker(picker, {api, persist: false, initial: value,
      onPartial: () => { draft = null; apply.disabled = true; if (!hydrating) status.textContent = 'Choose your vehicle, then apply it to update the wheels.'; },
      onVehicle: (vehicle, saved) => {
        draft = vehicle ? saved : null; apply.disabled = !draft;
        if (!hydrating) status.textContent = vehicle ? 'Ready to apply: ' + vehicle.label : 'No vehicle data found. Contact us for help.';
      }
    });
    fields.forEach(k => controls.el(k).setAttribute('aria-label', 'Vehicle ' + k));
    controls.ready.finally(() => { hydrating = false; });
  }
  apply.onclick = () => { if (draft) accept(draft, true); };
  clear.onclick = () => { accept(null); mount(null); };
  root.addEventListener('bd:clear-series-vehicle', () => { if (root._seriesVehicle) { accept(null); mount(null); } });
  new MutationObserver(links).observe(root.querySelector('[data-gallery]'), {childList: true});
  root.addEventListener('click', event => { if (event.target.closest('a')) links(); }, true);
  mount(initial); links();
})();
